import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

class MobileMenu {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._closes = document.querySelectorAll('[data-mobile-close]')
        this._trigger = document.querySelector('[data-mobile-trigger]')
        this._backBtns = document.querySelectorAll('[data-go-back]')
    }
    onInit () {
        this._trigger.addEventListener('click', e => {
            disableBodyScroll(this._elem)
        })
        this._closes.forEach(close => {
            close.addEventListener('click', e => {
                enableBodyScroll(this._elem)
            })
        })
        this._backBtns.forEach(back => {
            back.addEventListener('click', () => {
                document.querySelectorAll('.mobile-menu__children').forEach(elem => {
                    elem.classList.remove('children-open')
                })
            })
        })
    }
}

export default MobileMenu



// WEBPACK FOOTER //
// ./src/resources/scripts/components/MobileMenu.js